import {Box, Flex, FormLabel, Input} from '@chakra-ui/react';
import React, {useState, useRef, useEffect} from 'react';
import {CustomSelect} from '../General/FormInputs';
import {get} from '../../service/ApiService';
import {Location} from '../../service/Urls';
import ErrorHelper from '../../service/ErrorHelper';

// Takes in register, errors, and an id for the form value when page is submitted, setValue from react-hook forms and optional default value.
export const LocationSelect = props => {
  const [toast, setToast] = useState('');
  const [locations, setLocations] = useState([]);
  const locationInput = useRef(null);
  const [value, setValue] = useState('');

  useEffect(() => {
    if (props.defaultValue) {
      locationInput.current.value = props.defaultValue;
    }
  });

  useEffect(() => {
    if (locations[0]) {
      setValue(locations[0].id);
      if (props.setRHFValue) props.setRHFValue(props.id, locations[0].id);
    }
  }, [locations]);

  useEffect(() => {
    if (props.disabled) {
      locationInput.current.value = null;
      setLocations([]);
    }
  }, [props.disabled]);

  const getLocations = async () => {
    const data = locationInput.current.value;
    if (data === '') {
      return;
    } else if (data.match(/^[0-9]+$/) && data.length > 0 && props.clientId) {
      const response = await get(`${Location.GET_BY_CODE}?LocationCode=${data}&ClientId=${props.clientId ?? ''}`);
      response.name = response.clCname;
      setLocations(response ? [response] : []);
    } else if (data.toLowerCase().match(/^[a-z.',]+$/)) {
      const response = await get(`${Location.GET_BY_NAME}?LocationName=${data}&ClientId=${props.clientId ?? ''}`);
      setLocations(response.data ?? []);
    }
  };

  return (
    <Flex mr="auto" alignContent="bottom">
      <Box mr="1">
        <FormLabel htmlFor="account-rep" mb="-0.5" ml="1" fontSize="sm">
          Select
        </FormLabel>
        <Input ref={locationInput} onBlur={getLocations} placeholder="Location" disabled={props.disabled ?? false} />
      </Box>

      <Box w="100%">
        <CustomSelect
          id={props.id}
          register={props.register}
          errors={props.errors}
          value={value}
          onChange={e => setValue(e.target.value)}
          name="Select Location"
          disabled={props.disabled ?? false}
          required={props.required ? props.required : false}
        >
          {locations == []
            ? []
            : locations?.map(location => {
                return (
                  <option key={location.id} value={location.id}>
                    {location.loId} | {location.loName} | {location.loRptname}
                  </option>
                );
              })}
        </CustomSelect>
        <ErrorHelper toastResponse={toast} />
      </Box>
    </Flex>
  );
};
